export default __webpack_public_path__ + "static/Sand-88bcb6d05774875ef59afaf008e32029.png";